import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserEventsService {
  private userChangedSubject = new Subject<void>();

  userChanged$ = this.userChangedSubject.asObservable();

  emitUserChanged(): void {
    this.userChangedSubject.next();
  }
}
